var map = {
	"./icons/check.svg": [
		861,
		3
	],
	"./icons/cross.svg": [
		862,
		4
	],
	"./icons/error-page-icon.svg": [
		863,
		5
	],
	"./icons/exclamation.svg": [
		864,
		6
	],
	"./icons/ic-comprehensive-analysis.svg": [
		865,
		7
	],
	"./icons/ic-sources-analysis.svg": [
		866,
		8
	],
	"./icons/suspicion-status/no_problem.svg": [
		867,
		9
	],
	"./icons/suspicion-status/pending.svg": [
		868,
		10
	],
	"./icons/suspicion-status/problem.svg": [
		869,
		11
	],
	"./icons/suspicion-status/wrong_target.svg": [
		870,
		12
	],
	"./icons/suspicions/arson.svg": [
		871,
		13
	],
	"./icons/suspicions/assault.svg": [
		872,
		14
	],
	"./icons/suspicions/asset_misuse_misdemeanors.svg": [
		873,
		15
	],
	"./icons/suspicions/assets_misuse_offenses.svg": [
		874,
		16
	],
	"./icons/suspicions/banking_payment_offenses.svg": [
		875,
		17
	],
	"./icons/suspicions/black_market.svg": [
		876,
		18
	],
	"./icons/suspicions/capital_market_offenses.svg": [
		877,
		19
	],
	"./icons/suspicions/capital_offenses.svg": [
		878,
		20
	],
	"./icons/suspicions/child_pornography.svg": [
		879,
		21
	],
	"./icons/suspicions/clans.svg": [
		880,
		22
	],
	"./icons/suspicions/company_blacklist.svg": [
		881,
		23
	],
	"./icons/suspicions/copyright_infringement.svg": [
		882,
		24
	],
	"./icons/suspicions/corporate_governance_code.svg": [
		883,
		25
	],
	"./icons/suspicions/corporate_insurance_offenses.svg": [
		884,
		26
	],
	"./icons/suspicions/corporate_law_violations.svg": [
		885,
		27
	],
	"./icons/suspicions/corporate_logistics_offenses.svg": [
		886,
		28
	],
	"./icons/suspicions/corporate_obligations.svg": [
		887,
		29
	],
	"./icons/suspicions/corporate_operations.svg": [
		888,
		30
	],
	"./icons/suspicions/corruption.svg": [
		889,
		31
	],
	"./icons/suspicions/cybercrime.svg": [
		890,
		32
	],
	"./icons/suspicions/data_breach.svg": [
		891,
		33
	],
	"./icons/suspicions/data_security_breaches.svg": [
		892,
		34
	],
	"./icons/suspicions/debt_law_offenses.svg": [
		893,
		35
	],
	"./icons/suspicions/digital_black_markets.svg": [
		894,
		36
	],
	"./icons/suspicions/employment_relationships.svg": [
		895,
		37
	],
	"./icons/suspicions/exhibitionism.svg": [
		896,
		38
	],
	"./icons/suspicions/exploiting_leading_position.svg": [
		897,
		39
	],
	"./icons/suspicions/explosives.svg": [
		898,
		40
	],
	"./icons/suspicions/extortion.svg": [
		899,
		41
	],
	"./icons/suspicions/extremism_terror.svg": [
		900,
		42
	],
	"./icons/suspicions/fair_trading_offenses.svg": [
		901,
		43
	],
	"./icons/suspicions/financial_reporting.svg": [
		902,
		44
	],
	"./icons/suspicions/firearms.svg": [
		903,
		45
	],
	"./icons/suspicions/foreign_trade_law.svg": [
		904,
		46
	],
	"./icons/suspicions/fraud_consumer.svg": [
		905,
		47
	],
	"./icons/suspicions/hacking_attacks.svg": [
		906,
		48
	],
	"./icons/suspicions/health_safety_offenses.svg": [
		907,
		49
	],
	"./icons/suspicions/human_rights_violations.svg": [
		908,
		50
	],
	"./icons/suspicions/identity_theft.svg": [
		909,
		51
	],
	"./icons/suspicions/indications_for_crime.svg": [
		910,
		52
	],
	"./icons/suspicions/information_protection.svg": [
		911,
		53
	],
	"./icons/suspicions/insolvency_law_offenses.svg": [
		912,
		54
	],
	"./icons/suspicions/islamist_terror.svg": [
		913,
		55
	],
	"./icons/suspicions/it_security_breaches.svg": [
		914,
		56
	],
	"./icons/suspicions/labor_law_offenses.svg": [
		915,
		57
	],
	"./icons/suspicions/left_wing_extremism.svg": [
		916,
		58
	],
	"./icons/suspicions/malware.svg": [
		917,
		59
	],
	"./icons/suspicions/money_laundering.svg": [
		918,
		60
	],
	"./icons/suspicions/money_laundering_country_list.svg": [
		919,
		61
	],
	"./icons/suspicions/murder_manslaughter.svg": [
		920,
		62
	],
	"./icons/suspicions/negative_sentiment.svg": [
		921,
		63
	],
	"./icons/suspicions/no_internet_presence.svg": [
		922,
		64
	],
	"./icons/suspicions/offenses.svg": [
		923,
		65
	],
	"./icons/suspicions/offshore_leak.svg": [
		924,
		66
	],
	"./icons/suspicions/organized_crime.svg": [
		925,
		67
	],
	"./icons/suspicions/other_criminal_activities.svg": [
		926,
		68
	],
	"./icons/suspicions/potential_compliance_violation.svg": [
		927,
		69
	],
	"./icons/suspicions/procurement_law_offenses.svg": [
		928,
		70
	],
	"./icons/suspicions/product_safety.svg": [
		929,
		71
	],
	"./icons/suspicions/property_damage.svg": [
		930,
		72
	],
	"./icons/suspicions/property_offenses.svg": [
		931,
		73
	],
	"./icons/suspicions/ransomware.svg": [
		932,
		74
	],
	"./icons/suspicions/rape.svg": [
		933,
		75
	],
	"./icons/suspicions/red_light_milieu.svg": [
		934,
		76
	],
	"./icons/suspicions/right_wing_extremism.svg": [
		935,
		77
	],
	"./icons/suspicions/robbery_kidnapping.svg": [
		936,
		78
	],
	"./icons/suspicions/rockers.svg": [
		937,
		79
	],
	"./icons/suspicions/scam_fraud.svg": [
		938,
		80
	],
	"./icons/suspicions/sex_offenses.svg": [
		939,
		81
	],
	"./icons/suspicions/sexual_assault.svg": [
		940,
		82
	],
	"./icons/suspicions/social_security_fraud.svg": [
		941,
		83
	],
	"./icons/suspicions/substance_abuse.svg": [
		942,
		84
	],
	"./icons/suspicions/sunsidies_funding_offenses.svg": [
		943,
		85
	],
	"./icons/suspicions/sustainability_environment.svg": [
		944,
		86
	],
	"./icons/suspicions/tax_offenses.svg": [
		945,
		87
	],
	"./icons/suspicions/theft.svg": [
		946,
		88
	],
	"./icons/suspicions/trade_secrets.svg": [
		947,
		89
	],
	"./icons/suspicions/transactions.svg": [
		948,
		90
	],
	"./icons/suspicions/violent_crimes.svg": [
		949,
		91
	],
	"./icons/suspicions/weapon_offenses.svg": [
		950,
		92
	],
	"./icons/suspicions/white_collar_crime.svg": [
		951,
		93
	],
	"./icons/suspicions/wrong_notices.svg": [
		952,
		94
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 817;
module.exports = webpackAsyncContext;